import { ModalContainer, ModalLayoutCenter } from "@kanda-libs/ks-component-ts";
import type { FunctionComponent, MutableRefObject } from "react";
import { MODAL_ID } from "./constants";

export interface ModalProps {
  children: JSX.Element;
}

const Modal: FunctionComponent<ModalProps> = function ({ children }) {
  return (
    <ModalContainer id={MODAL_ID}>
      {({ handleClose, ref }) => (
        <ModalLayoutCenter
          ref={ref as MutableRefObject<HTMLDivElement>}
          onClose={handleClose}
          id={MODAL_ID}
        >
          {children}
        </ModalLayoutCenter>
      )}
    </ModalContainer>
  );
};

export default Modal;
